export default () => {
  return { error: false, message: "Investor group deleted" };
};
